"use client"

import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import Header from "@/ui/layout/Header"
import SanityMenu from "../SanityMenu"
import { PageLayout } from "@/contents/sanityTypes"
import { ThemeColor } from "@punks/ui-core"
import { toLink } from "@/contents/converters/links"
import { access } from "fs"
import { usePathname } from "next/navigation"

export interface SanityHeaderProps {
  content: any
  layout?: PageLayout
  menuOpen: boolean
  menuColor?: ThemeColor
  locale: string
  onMenuClick: () => void
  onMenuClose: () => void
}

const SanityHeader = ({
  content,
  layout,
  menuOpen,
  menuColor,
  locale,
  onMenuClick,
  onMenuClose,
}: SanityHeaderProps) => {
  const path = usePathname()

  return (
    <>
      <Header
        logo={
          <SanityImageField
            width={200}
            height={200}
            asset={
              layout?.headerVariant === "transparent"
                ? content.logoNegative
                : content.logo
            }
          />
        }
        position={
          layout?.headerVariant === "transparent" ? "absolute" : "default"
        }
        variant={layout?.headerVariant ?? "default"}
        onMenuClick={() => onMenuClick()}
        menuIcon="burger"
        menuColor={menuColor}
        links={content.menuItems.map((item: any) => ({
          label: item.label,
          link: toLink(item.link),
          active: path?.endsWith(toLink(item.link)?.url ?? ""),
        }))}
      />
      <div>
        <SanityMenu
          locale={locale}
          content={content}
          open={menuOpen}
          onClose={() => onMenuClose()}
        />
      </div>
    </>
  )
}

export default SanityHeader
